import * as Types from 'app/types/schema';

import gql from 'graphql-tag';
import * as Urql from 'app/libs/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type NetworkAssetsDetailQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.NetworkAssetsFilters>;
  sorts?: Types.InputMaybe<Array<Types.SortProps> | Types.SortProps>;
  limit?: Types.InputMaybe<Types.Scalars['Float']>;
  after?: Types.InputMaybe<Types.Scalars['String']>;
  before?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type NetworkAssetsDetailQuery = { __typename?: 'Query', networkAssets: { __typename?: 'NetworkAssetConnection', success: boolean, errorCode?: Types.PaginationErrorCodeEnum | null, totalCount: number, edges: Array<{ __typename?: 'NetworkAssetEdge', node: { __typename?: 'NetworkAssetSchema', id: string, mac?: string | null, userName?: string | null, email?: string | null, serialNumber?: string | null, modelNumber?: string | null, ipAddress?: string | null, type?: Types.NetworkAssetTypeEnum | null, status: Types.NetworkAssetStatusEnum, software?: Array<string> | null, createdById?: string | null, updatedById?: string | null, tenantId?: string | null, createdAt: string, updatedAt: string, site?: { __typename?: 'LocationSchema', id: string, name: string } | null, location?: { __typename?: 'LocationSchema', id: string, name: string } | null, note?: { __typename?: 'NoteSchema', heading?: string | null, note?: string | null } | null, battery?: { __typename?: 'BatterySchema', hasBattery?: boolean | null, cycleCount?: number | null, isCharging?: boolean | null, designedCapacity?: number | null, maxCapacity?: number | null, currentCapacity?: number | null, voltage?: number | null, capacityUnit?: string | null, percent?: number | null, timeRemaining?: number | null, acConnected?: boolean | null, type?: string | null, model?: string | null, manufacturer?: string | null, serial?: string | null } | null, bios?: { __typename?: 'BiosSchema', vendor?: string | null, version?: string | null, releaseDate?: string | null } | null, cpu?: { __typename?: 'CpuSchema', manufacturer?: string | null, brand?: string | null, vendor?: string | null, family?: string | null, model?: string | null, stepping?: string | null, revision?: string | null, voltage?: string | null, speed?: number | null, speedMin?: number | null, speedMax?: number | null, governor?: string | null, cores?: number | null, physicalCores?: number | null, performanceCores?: number | null, efficiencyCores?: number | null, processors?: number | null, socket?: string | null, flags?: string | null, virtualization?: boolean | null } | null, disk?: Array<{ __typename?: 'DiskSchema', type?: string | null, size?: number | null, used?: number | null, available?: number | null, use?: number | null, mount?: string | null, readWrite?: boolean | null, fileSystem?: string | null }> | null, display?: Array<{ __typename?: 'DisplaySchema', vendor?: string | null, model?: string | null, deviceName?: string | null, main?: boolean | null, builtin?: boolean | null, connection?: string | null, currentResX?: number | null, currentResY?: number | null, currentRefreshRate?: number | null }> | null, graphics?: Array<{ __typename?: 'GraphicsSchema', vendor?: string | null, model?: string | null, bus?: string | null, busAddress?: string | null, vram?: number | null, vramDynamic?: boolean | null, pciID?: string | null }> | null, memory?: { __typename?: 'MemorySchema', total?: number | null, free?: number | null, used?: number | null, active?: number | null, available?: number | null, buffers?: number | null, cached?: number | null, slab?: number | null, buffcache?: number | null, swaptotal?: number | null, swapfree?: number | null, swapused?: number | null } | null, motherboard?: { __typename?: 'MotherBoardSchema', manufacturer?: string | null, model?: string | null, version?: string | null, serial?: string | null, assetTag?: string | null } | null, network?: Array<{ __typename?: 'NetworkSchema', iface?: string | null, ifaceName?: string | null, default?: boolean | null, ip4?: string | null, ip4subnet?: string | null, ip6?: string | null, ip6subnet?: string | null, mac?: string | null, internal?: boolean | null, virtual?: boolean | null, operstate?: string | null, type?: string | null, duplex?: string | null, mtu?: number | null, dhcp?: boolean | null }> | null, port?: Array<{ __typename?: 'PortSchema', process?: string | null, protocol?: string | null, localAddress?: string | null, localPort?: string | null, peerAddress?: string | null, peerPort?: string | null, state?: string | null, pid?: number | null }> | null, process?: { __typename?: 'ProcessSchema', all?: number | null, running?: number | null, blocked?: number | null, sleeping?: number | null, unknown?: number | null } | null, storage?: Array<{ __typename?: 'StorageSchema', device?: string | null, type?: string | null, name?: string | null, vendor?: string | null, size?: number | null, serialNum?: string | null, firmwareRevision?: string | null, interfaceType?: string | null, smartStatus?: string | null }> | null, system?: { __typename?: 'SystemSchema', manufacturer?: string | null, model?: string | null, version?: string | null, serial?: string | null, uuid?: string | null, sku?: string | null, virtual?: boolean | null } | null, operatingSystem?: { __typename?: 'OsSchema', platform?: string | null, distro?: string | null, release?: string | null, codename?: string | null, kernel?: string | null, arch?: string | null, hostname?: string | null, fqdn?: string | null, codepage?: string | null, logofile?: string | null, serial?: string | null, build?: string | null, servicepack?: string | null, uefi?: boolean | null } | null, warranty?: { __typename?: 'WarrantySchema', startDate?: string | null, endDate?: string | null, serial?: string | null } | null } }>, pageInfo?: { __typename?: 'PageInfo', hasNextPage: boolean, hasPrevPage: boolean, nextCursor?: string | null, prevCursor?: string | null } | null } };


export const NetworkAssetsDetailDocument = gql`
    query networkAssetsDetail($filters: NetworkAssetsFilters, $sorts: [SortProps!], $limit: Float, $after: String, $before: String) {
  networkAssets(
    filters: $filters
    sorts: $sorts
    limit: $limit
    after: $after
    before: $before
  ) {
    edges {
      node {
        id
        mac
        userName
        email
        site {
          id
          name
        }
        location {
          id
          name
        }
        serialNumber
        modelNumber
        ipAddress
        type
        status
        note {
          heading
          note
        }
        battery {
          hasBattery
          cycleCount
          isCharging
          designedCapacity
          maxCapacity
          currentCapacity
          voltage
          capacityUnit
          percent
          timeRemaining
          acConnected
          type
          model
          manufacturer
          serial
        }
        bios {
          vendor
          version
          releaseDate
        }
        cpu {
          manufacturer
          brand
          vendor
          family
          model
          stepping
          revision
          voltage
          speed
          speedMin
          speedMax
          governor
          cores
          physicalCores
          performanceCores
          efficiencyCores
          processors
          socket
          flags
          virtualization
        }
        disk {
          type
          size
          used
          available
          use
          mount
          readWrite
          fileSystem
        }
        display {
          vendor
          model
          deviceName
          main
          builtin
          connection
          currentResX
          currentResY
          currentRefreshRate
        }
        graphics {
          vendor
          model
          bus
          busAddress
          vram
          vramDynamic
          pciID
        }
        memory {
          total
          free
          used
          active
          available
          buffers
          cached
          slab
          buffcache
          swaptotal
          swapfree
          swapused
        }
        motherboard {
          manufacturer
          model
          version
          serial
          assetTag
        }
        network {
          iface
          ifaceName
          default
          ip4
          ip4subnet
          ip6
          ip6subnet
          mac
          internal
          virtual
          operstate
          type
          duplex
          mtu
          dhcp
        }
        port {
          process
          protocol
          localAddress
          localPort
          peerAddress
          peerPort
          state
          pid
        }
        process {
          all
          running
          blocked
          sleeping
          unknown
        }
        storage {
          device
          type
          name
          vendor
          size
          serialNum
          firmwareRevision
          interfaceType
          smartStatus
        }
        system {
          manufacturer
          model
          version
          serial
          uuid
          sku
          virtual
        }
        operatingSystem {
          platform
          distro
          release
          codename
          kernel
          arch
          hostname
          fqdn
          codepage
          logofile
          serial
          build
          servicepack
          uefi
        }
        software
        warranty {
          startDate
          endDate
          serial
        }
        createdById
        updatedById
        tenantId
        createdAt
        updatedAt
      }
    }
    pageInfo {
      hasNextPage
      hasPrevPage
      nextCursor
      prevCursor
    }
    success
    errorCode
    totalCount
  }
}
    `;

export function useNetworkAssetsDetailQuery(options?: Omit<Urql.UseQueryArgs<NetworkAssetsDetailQueryVariables>, 'query'>) {
  return Urql.useQuery<NetworkAssetsDetailQuery>({ query: NetworkAssetsDetailDocument, ...options });
};